<template>
  <div class="lg:pt-0 relative z-10">

    <folder-modal
      :isModalVisible="showFolderModal"
      :folder="path"
      @select="navToFolder"
      @close="showFolderModal = false" />

    <tag-modal
      :isModalVisible="showTagModal"
      :tags="tags"
      @addtag="addTagToNav"
      @rmtag="rmTagFromNav"
      @close="showTagModal = false" />

    <add-record-modal :isModalVisible="showRecordModal" @close="showRecordModal = false" />

    <div class="relative pb-4 bg-light-yellow lg:rounded mb-6">
      <div class="flex justify-between items-center pb-8">
        <div class="font-bold text-xl tracking-wide font-mono flex flex-wrap items-end">
          <div v-for="(f, i) in folders" class="flex">
            <div>
              <div
                class="px-2 py-2 block no-underline cursor-pointer path-seg mr-1"
                :class="{
                  'last rounded': i + 1 === folders.length
                }"
                @click.prevent="handleSegNav(f.path)">{{f.seg}}/</div>
            </div>
          </div>
        </div>

        <div
          class="cursor-pointer text-xs underline text-right text-black relative px-2"
          @click.prevent="showFolderModal = true">Change Folder</div>
      </div>


      <div class="flex items-center justify-between px-2">
        <div class="flex items-center">
          <div class="flex">

            <div
              @click.prevent="navPage('notes')"
              class="cursor-pointer block text-xs tracking-wide text-black sub-nav-item underline mr-2"
              :class="{
                'no-underline text-black font-bold': pageName === 'notes'
              }">All Notes</div>


            <div
              @click.prevent="navPage('todos')"
              class="cursor-pointer block text-xs tracking-wide text-black sub-nav-item underline mr-2"
              :class="{
                'no-underline text-black font-bold': pageName === 'todos'
              }">Todos</div>

            <div
              @click.prevent="navPage('events')"
              class="cursor-pointer block text-xs tracking-wide text-black sub-nav-item underline mr-2"
              :class="{
                'no-underline text-black font-bold': pageName === 'events'
              }">Events</div>

            <div
              @click.prevent="navPage('beans')"
              class="cursor-pointer block text-xs tracking-wide text-black sub-nav-item underline mr-2"
              :class="{
                'no-underline text-black font-bold': pageName === 'beans'
              }">Beans</div>
          </div>


          <div
            class="flex border-l-2 border-black pl-4"
            @click="showTagModal = true;">

            <div
              class="cursor-pointer text-xs text-black relative flex text-xs">
              <span class="underline">Filter Tags</span>
              <span v-if="tags && tags.length > 1" class="font-bold underline">&nbsp;({{tags.length}})</span>
              <span v-else-if="tags && tags.length == 1">:
                <span
                  v-for="t in tags"
                  class="font-mono tag font-bold"
                  v-html="parsedSymbol('#' + t)">
                </span></span>

            </div>


          </div>
        </div>

      </div>
    </div>
    <div>
      <div class="flex justify-between px-2 pb-6">
        <h2 class="text-2xl">{{pageTitle}} <a v-if="type !== 'Notes'" :href="'https://www.tatatap.com/' + type" target="_blank" class="text-xs font-normal">About</a></h2>
        <div
          class="no-underline text-center text-xs font-bold bg-full-blue text-white p-2 rounded cursor-pointer"
          @click="showRecordModal=true">Add Note</div>
      </div>
    </div>
  </div>
</template>


<script>
 import path from 'path';
 import AddRecordModal from './AddRecordModal';
 import FolderModal from '@/components/FolderModal';
 import TagModal from '@/components/TagModal';

 export default {
   props: {
     type: {
       type: String,
       default: 'notes'
     },

     action: {
       type: String,
       default: 'Viewing'
     },

     page: {
       type: String,
       default: 'home'
     },
     params: {
       type: Object,
       default: () => ({})
     },
     path: {
       type: String,
       default: ''
     },
     tags: {
       type: Array,
       default: []
     },

   },

   components: {TagModal, FolderModal, AddRecordModal},
   data () {
     return {
       showTagModal: false,
       showFolderModal: false,
       showRecordModal: false
     }
   },

   computed: {
     folders () {
       const segs = path.join('/', this.path, '/')
                        .split('/')
                        .filter((s, i) => i < 1 || !!s)
                        .reduce((acc, s) => {
                          acc.push({
                            // NOTE this takes what has accumulated so far and squashes it together
                            path: path.join.apply(
                              null,
                              ['/'].concat(acc.map(i => i.seg))
                                   .concat(s))
                                      .substr(1),
                            seg: s
                          });
                          return acc;
                        }, []);

       return segs;
     },

     pageName () {
       return this.$route.name;
     },

     pageTitle () {

       return ({
         notes: 'All Notes',
         todos: 'Todos',
         events: 'Events',
         beans: 'Beans'})[this.pageName];
     }

   },

   methods: {
     navPage (page) {
       this.$nav(page, {});
     },


     addTagToNav (tag) {
       this.$nav(this.$route.name,
                 {
                   tags: ':t:' + (this.tags).concat([tag]).unique().join(','),
                 }
       );
     },

     navToFolder(folder) {
       this.$nav(this.$route.name, {
         folder
       });


       this.showFolderModal = false
     },

     rmTagFromNav (tag) {
       const tags = [].concat(this.tags);

       const index = tags.indexOf(tag);

       if (index !== -1) {
         tags.splice(index, 1)
       }

       this.$nav(
         this.$route.name,
         {
           tags: tags.length ? ':t:' + tags.join(',') : '/',
       });
     },

     handleSegNav (seg) {
       this.$nav(
         this.$route.name,
         {
           folder: path.join('/', seg),
       })
     },
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     }
   }
 }
</script>


<style>
 .path-seg {
   background: rgba(255,255,255, 1);
   opacity: .4;
 }

 .path-seg.last {
   background-color: #f3ca20;
   opacity: 1;
 }

</style>
